import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { NetworkGlyph } from './NetworkGlyph';

interface NetworkBadgeProps {
  network: string | null;
  padding?: number;
}

/** The translucent-white chip a creative thumbnail overlays its network icon on — shared by every
 * table cell and grid card, which only differ in padding (table: 0.5, grid: 1). */
export function NetworkBadge({ network, padding = 1 }: NetworkBadgeProps): ReactNode {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        bgcolor: alpha(theme.palette.common.white, 0.75),
        borderRadius: 1,
        p: padding,
      })}
    >
      <NetworkGlyph network={network} />
    </Box>
  );
}
